import { useState, useEffect } from 'react';

const OTP_DELAY = 30;
const RESEND_DELAY = 180;
const ONE_SECOND_MS = 1000;

function useResendTimer(delay) {
    const [secondsLeft, setSecondsLeft] = useState(0);

    useEffect(() => {
        if (secondsLeft === 0) return;

        const timer = setTimeout(() => setSecondsLeft(prev => prev - 1), ONE_SECOND_MS);

        return () => clearTimeout(timer);
    }, [secondsLeft]);

    const startTimer = () => setSecondsLeft(delay);

    return { secondsLeft, startTimer };
}

export {
    useResendTimer,
    OTP_DELAY,
    RESEND_DELAY
};
